import { useEffect, useState } from "react";
import { fetchAPI, postAPI } from "../../utils/utils";
import Select from 'react-select';
import { getCastellerDisplayName } from "../../utils/castellerName";

// Add CSS for the etiqueta title hover effect
const etiquetaTitleStyle = `
    .etiqueta-title:hover {
        background-color: #e0e0e0;
    }
    
    .etiqueta-title:hover .edit-icon {
        opacity: 1;
    }
    
    .delete-button:hover {
        background-color: #ff8888 !important;
    }
`;

function Etiqueta({
    etiqueta,
    usersEtiquetes,
    setUsersEtiquetes,
    castellersInfo,
    delete_etiqueta,
    displayName,
    socket,
}) {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editedName, setEditedName] = useState(etiqueta.nom);

    const handleRename = () => {
        if (editedName.trim() === '') return;
        if (editedName === etiqueta.nom) {
            setIsEditing(false);
            return;
        }

        postAPI(
            '/rename_etiqueta',
            { id: etiqueta.id, nom: editedName },
            () => {
                setIsEditing(false);
            }
        );
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleRename();
        } else if (e.key === 'Escape') {
            setEditedName(etiqueta.nom);
            setIsEditing(false);
        }
    };

    const updateEtiquetaUsers = (etiquetaId, newSelectedUsers) => {
        const oldSelectedUsers = usersEtiquetes?.[etiquetaId] || [];
        const usersToAdd = newSelectedUsers?.filter(user => !oldSelectedUsers?.some(oldUser => oldUser.id === user.id)) || [];
        const usersToRemove = oldSelectedUsers?.filter(oldUser => !newSelectedUsers?.some(user => user.id === oldUser.id)) || [];

        setUsersEtiquetes({
            ...usersEtiquetes,
            [etiquetaId]: newSelectedUsers
        });

        usersToAdd.forEach(user => {
            postAPI(
                '/add_etiqueta',
                { user: user.id, etiqueta: etiquetaId },
                () => {},
            );
        });

        usersToRemove.forEach(user => {
            postAPI(
                '/drop_etiqueta',
                { user: user.id, etiqueta: etiquetaId },
                () => {},
            );
        });
    }

    const allOptions = Object.values(castellersInfo || {})
        .sort((a, b) => a.altura > b.altura ? 1 : -1)
        .map(user => ({
            value: user.id,
            label: displayName(user),
            color: 'black'
        }));

    return (
        <div
            key={etiqueta.id}
            className="etiqueta"
            style={{
                flexWrap: 'wrap',
                margin: 10,
                padding: 20,
                borderRadius: 5,
                backgroundColor: '#eee',
                gap: 5,
                width: 250,
                height: '100%',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                {isEditing ? (
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        gap: '5px',
                        marginTop: 15,
                        marginBottom: 16,
                        marginRight: 15,
                    }}>
                        <input
                            type="text"
                            value={editedName}
                            onChange={(e) => setEditedName(e.target.value)}
                            onBlur={handleRename}
                            onKeyDown={handleKeyDown}
                            autoFocus
                            style={{
                                fontSize: '1.17em',
                                fontWeight: 'bold',
                                margin: 0,
                                padding: '5px',
                                border: '1px solid #ccc',
                                borderRadius: '3px',
                                width: '100px'
                            }}
                        />
                        <button 
                            onClick={handleRename}
                            style={{
                                backgroundColor: '#4CAF50',
                                color: 'white',
                                border: 'none',
                                borderRadius: '3px',
                                padding: '5px 8px',
                                cursor: 'pointer',
                                fontSize: '16px'
                            }}
                            title="Confirmar"
                        >
                            ✓
                        </button>
                    </div>
                ) : (
                    <h3 
                        onDoubleClick={() => setIsEditing(true)}
                        style={{ 
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                            position: 'relative',
                            padding: '3px',
                            borderRadius: '3px',
                            transition: 'background-color 0.2s'
                        }}
                        className="etiqueta-title"
                        title="Clica per editar"
                        onClick={() => setIsEditing(true)}
                    >
                        {etiqueta.nom}
                        <span 
                            className="edit-icon"
                            style={{ 
                                fontSize: '16px', 
                                opacity: '0.7',
                                marginLeft: '5px',
                                color: '#b0b0b0'
                            }}
                        >
                            ✏️
                        </span>
                    </h3>
                )}
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: 10,
                    }}
                >
                    <button onClick={() => setIsCollapsed(!isCollapsed)}>{isCollapsed ? '+' : '-'}</button>
                    <button style={{ backgroundColor: '#ffaaaa' }} onClick={() => delete_etiqueta(etiqueta)}>🗑️</button>
                </div>
            </div>

            {
                isCollapsed && (
                    <span>Clica <strong>+</strong> per desplegar</span>
                )
            }

            {!isCollapsed && (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: 5,
                    }}
                >
                    <Select
                        isMulti
                        name="users"
                        options={allOptions}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        isClearable={false}
                        value={
                            usersEtiquetes?.[etiqueta.id]
                                ?.filter(user => user)
                                ?.map(user => ({
                                    value: user.id,
                                    label: displayName(user),
                                    color: 'black'
                                }))
                        }
                        onChange={(selectedOptions) => {
                            const selectedUserIds = selectedOptions
                                ?.map(option => option.value)
                                ?.map(id => castellersInfo?.[id])

                            updateEtiquetaUsers(etiqueta.id, selectedUserIds);
                        }}
                    />

                    {
                        usersEtiquetes?.[etiqueta.id]?.length === 0 && (
                            <span style={{ margin: 10 }}>No hi ha cap casteller amb aquesta etiqueta</span>
                        )
                    }
                </div>
            )}
        </div>
    )
}

function UsersEtiquetes({ allEtiquetes, setAllEtiquetes, castellersInfo, socket }) {
    // List all users with their etiquetes
    const [usersEtiquetes, setUsersEtiquetes] = useState({});
    
    const displayName = user => {
        const { altura, canalla } = user;

        const canalla_part = canalla ? '👶' : '';
        const nom_part = getCastellerDisplayName(user);
        const altura_part = altura !== null && !isNaN(altura) ? `(${altura})` : `(Sense altura)`;

        return `${canalla_part} ${nom_part} ${altura_part}`;
    }

    const create_etiqueta = (force_nom=null) => {
        const nom = force_nom ? force_nom : prompt('Nom de l\'etiqueta:');
        if (nom) {
            postAPI(
                '/create_etiqueta',
                { nom },
                () => fetchAPI('/etiquetes', setAllEtiquetes),
            );
        }
    }

    const delete_etiqueta = ({ id }) => {
        if (window.confirm(`Estàs segur que vols eliminar l'etiqueta "${allEtiquetes.find(e => e.id === id).nom}"?`)) {
            postAPI(
                '/delete_etiqueta',
                { id },
                () => fetchAPI('/etiquetes', setAllEtiquetes),
            );
        }
    }

    useEffect(() => {
        const handleEtiquetaRenamed = ({ id, nom }) => {
            setAllEtiquetes(prev => prev.map(etiqueta => 
                etiqueta.id === id ? { ...etiqueta, nom } : etiqueta
            ));
        };

        socket.on('.etiqueta_renamed', handleEtiquetaRenamed);

        return () => {
            socket.off('.etiqueta_renamed', handleEtiquetaRenamed);
        };
    }, []);

    useEffect(() => {
        if (!allEtiquetes || !castellersInfo) return;

        allEtiquetes.forEach(etiqueta => {
            fetchAPI('/etiqueta_users/' + etiqueta.id, data => {
                setUsersEtiquetes(prev => ({
                    ...prev,
                    [etiqueta.id]: data
                        .map(user => castellersInfo?.[user.id]),
                }));
            });
        });
    }, [
        allEtiquetes,
        castellersInfo,
    ]);

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2>Etiquetes</h2>
                <button onClick={() => create_etiqueta()}>Crea una nova etiqueta</button>
            </div>

            <div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        justifyContent: 'space-around',
                    }}
                >
                    {
                        allEtiquetes.map(etiqueta => (
                            <Etiqueta
                                key={etiqueta.id}
                                socket={socket}
                                etiqueta={etiqueta}
                                usersEtiquetes={usersEtiquetes}
                                setUsersEtiquetes={setUsersEtiquetes}
                                castellersInfo={castellersInfo}
                                delete_etiqueta={delete_etiqueta}
                                displayName={displayName}
                            />
                        ))
                    }
                </div>
            </div>

            <h2 style={{ padding: '10px' }}>Persones sense etiqueta</h2>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {
                    Object.values(castellersInfo || {})
                        .filter(user => !allEtiquetes.some(etiqueta => usersEtiquetes[etiqueta.id]?.some(etiquetaUser => etiquetaUser?.id === user?.id)))
                        .sort((a, b) => a.altura > b.altura ? 1 : -1)
                        .map(user => (
                            <div key={user.id} style={{ padding: '5px', margin: '5px', backgroundColor: '#eee', borderRadius: '5px', boxShadow: '0px 0px 5px rgba(0,0,0,0.1)' }}>
                                {displayName(user)}
                            </div>
                        ))
                }
            </div>
        </div>
    )
}

export default UsersEtiquetes;
